export default __webpack_public_path__ + "static/media/p1-screenshot-4.696799d5.png";